import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Primer Brand is `}<a parentName="p" {...{
        "href": "https://github.com/primer/brand"
      }}>{`open-sourced on GitHub`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@primer/react-brand"
      }}>{`available on npm`}</a>{`.`}</p>
    <h3>{`1. Install Primer Brand`}</h3>
    <p>{`Install Primer Brand with `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/"
      }}>{`npm`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install @primer/react-brand
`}</code></pre>
    <h3>{`2. Import global stylesheets`}</h3>
    <p>{`Primer Brand requires a global stylesheet to be loaded ahead-of-time.`}</p>
    <h4>{`a. Using an application bundler (e.g. Webpack)`}</h4>
    <p>{`Import the `}<inlineCode parentName="p">{`main`}</inlineCode>{` stylesheet at the earliest rendering opportunity:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@primer/react-brand/lib/css/main.css'
`}</code></pre>
    <p>{`or`}</p>
    <h4>{`b. Using a static stylesheet`}</h4>
    <p>{`Load the static stylesheet if you're unable to import stylesheets using a bundler`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<link
  href="https://unpkg.com/browse/@primer/react-brand@<version>/lib/css/main.css"
  rel="stylesheet"
/>
`}</code></pre>
    <h3>{`3. (Optional) Import the custom font assets`}</h3>
    <p>{`Primer Brand references the `}<inlineCode parentName="p">{`Mona Sans`}</inlineCode>{` typeface, which will need to be loaded alongside the main stylesheet.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@primer/react-brand/fonts/fonts.css'
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<link
  href="https://unpkg.com/browse/@primer/react-brand@<version>/fonts/fonts.css"
  rel="stylesheet"
/>
`}</code></pre>
    <h3>{`4. Use the ThemeProvider`}</h3>
    <p>{`You must add the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` to the root of your application for theming to work correctly.`}</p>
    <p>{`E.g.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {ThemeProvider} from '@primer/react-brand'

function App() {
  return (
    <ThemeProvider>
      <div>...</div>
    </ThemeProvider>
  )
}
`}</code></pre>
    <h3>{`5. Import components`}</h3>
    <p>{`Components can be imported into any React-based application.`}</p>
    <p>{`E.g.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Hero} from '@primer/react-brand'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Hero {...props} />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      